/**
 * Esqueleto de carga de las pantallas de Academia Atlas
 * (ADR-2026-08-25-la-academia-vive-en-supabase).
 *
 * Con el contenido en la base, todas las pantallas tienen un momento sin datos
 * que antes no existía: el catálogo venía en el bundle y estaba desde el primer
 * frame. Un esqueleto y no un spinner porque reserva el alto de lo que viene, y
 * así el título no salta cuando llegan los cursos.
 *
 * Uno solo para las cuatro pantallas: no dibuja la forma exacta de cada una
 * —eso sería cuatro esqueletos que mantener— sino el bloque de encabezado, que
 * es lo que todas comparten arriba del pliegue.
 */
export function EsqueletoAcademia() {
  return (
    <div
      className="mx-auto max-w-content px-4 pb-24 pt-2 sm:px-8 md:pb-8"
      aria-busy="true"
      aria-label="Cargando"
    >
      <div className="animate-pulse">
        {/* Como la pantalla: en el teléfono el medallón a la izquierda del título. */}
        <div className="flex items-center gap-3 md:block">
          <div className="h-11 w-11 shrink-0 rounded-2xl bg-black/[0.06]" />
          <div className="h-8 w-[220px] rounded-lg bg-black/[0.06] md:mt-4 md:w-[280px]" />
        </div>
        <div className="mt-3 h-4 w-full max-w-[520px] rounded bg-black/[0.05]" />
        <div className="mt-2 h-4 w-full max-w-[420px] rounded bg-black/[0.05]" />

        <div className="mt-10 h-6 w-[200px] rounded bg-black/[0.06]" />
        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="overflow-hidden rounded-2xl border border-black/[0.06] bg-white"
            >
              <div className="aspect-[16/10] bg-black/[0.05]" />
              <div className="p-4">
                <div className="h-4 w-3/4 rounded bg-black/[0.06]" />
                <div className="mt-2 h-3 w-full rounded bg-black/[0.04]" />
                <div className="mt-1.5 h-3 w-2/3 rounded bg-black/[0.04]" />
                <div className="mt-5 h-1.5 w-full rounded-full bg-black/[0.05]" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
